var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberCardBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 46,
    viewBox: "0 0 72 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "member_card_back",
    transform: "translate(-24 -40.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3284",
    "data-name": "Group 3284",
    transform: "translate(24 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3283",
    "data-name": "Group 3283"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    width: 72,
    height: 46,
    rx: 10,
    transform: "translate(0 0.04)",
    fill: "#e5edf8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285",
    transform: "translate(29.76 47.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11373",
    "data-name": "Path 11373",
    d: "M344,144h8.64v2.88H344Z",
    transform: "translate(-292.16 -115.2)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11374",
    "data-name": "Path 11374",
    d: "M296,144h5.76v2.88H296Z",
    transform: "translate(-252.8 -115.2)",
    fill: "#fafdff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberCardBack);
export default __webpack_public_path__ + "static/media/member_card_back.7c8cd33a7ceb97144111ac83dca7ab09.svg";
export { ForwardRef as ReactComponent };